export enum TransactionErrors {
  CASH_LIMIT_EXCEEDED = '-43'
}
